import Modal from 'common_components/ui/modal/modal.ui';
import { Assets, FontFamily, PrimaryButton } from 'utils/imports.utils';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';
import { STRINGS } from 'constants/strings.constant';
import './unsaved_changes_modal.component.scss';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  isSaving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  // The close icon, Esc and a click outside all mean "stay in the editor".
  onClose: () => void;
}

const UnsavedChangesModal = (props: UnsavedChangesModalProps) => {
  const copy = STRINGS.navBar.unsavedChanges;
  // A save in flight owns the modal: the other exits would leave while it is still running.
  const guard = (action: () => void) => () => {
    if (!props.isSaving) action();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={guard(props.onClose)}>
      <div className="unsaved-changes">
        <img
          className="unsaved-changes-close"
          src={Assets.close}
          alt="close"
          onClick={guard(props.onClose)}
        />
        <div className="unsaved-changes-container">
          <div className="unsaved-changes-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 9v4M12 17h.01" />
              <path d="M10.3 3.9 2.4 17.5A2 2 0 0 0 4.1 20.5h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
            </svg>
          </div>
          <div className="unsaved-changes-title">{copy.title}</div>
          <div className="unsaved-changes-message">{copy.message}</div>
          <div className="unsaved-changes-actions">
            <div className="unsaved-changes-actions-button">
              <PrimaryButton
                text={copy.save}
                type={ButtonTypes.PRIMARY}
                size={ButtonSize.SMALL}
                fontFamily={FontFamily.medium}
                onClick={props.onSave}
                activity={props.isSaving}
              />
            </div>
            <div className="unsaved-changes-actions-button">
              <PrimaryButton
                text={copy.discard}
                type={ButtonTypes.OUTLINED}
                size={ButtonSize.SMALL}
                fontFamily={FontFamily.medium}
                style={{ border: '1px solid #dc2626', color: '#dc2626' }}
                onClick={guard(props.onDiscard)}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UnsavedChangesModal;
